import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Pipe,
  PipeTransform,
  ChangeDetectorRef,
  AfterViewChecked
} from '@angular/core';
import {jsPDF} from "jspdf";
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';


import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2/dist/sweetalert2.js'


import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TraslateService} from '../traslate.service';
import {PdfUtil} from './PdfUtil';
import {CircleProgressComponent} from 'ng-circle-progress';
import {HttpClient, HttpHeaders} from '@angular/common/http';


import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, ErrorStateMatcher, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {Moment} from 'moment';
import {first, map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {ThrowStmt} from '@angular/compiler';
import {NgxSpinnerService} from 'ngx-spinner';
import {stringify} from 'querystring';
import {IndexedAccessType} from 'typescript';
import * as internal from 'stream';
import {ActivatedRoute} from '@angular/router';
import {UserService} from '../_services';
import {async} from 'rxjs/internal/scheduler/async';

const moment = _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-vehicle',
  templateUrl: './vehicle.component.html',
  styleUrls: ['./vehicle.component.scss']
})


export class VehicleComponent implements OnInit, AfterViewChecked {
  repos: any;
  URL: RequestInfo;
  dataSource: MatTableDataSource<any>;
  matcher = new MyErrorStateMatcher();


  displayedColumns: string[] = ['select', 'icon', 'name', 'device_id', 'plate', 'calibration', 'company', 'boitier_sim', 'action'];
  displayedColumns2: string[] = ['calibration', 'name', 'unit_type', 'plate', 'company'];
  selection = new SelectionModel(true, []);
  filterSelectObj
  dd: void;
  listItems: any = [];
  manualPage: number = 0;
  lengthpage: number = 100;
  pageNum: any;

  manualPage1: number;
  lengthTotal: any;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [15, 30, 100];
  public dateTime: Date
  index2: any = 15;
  myControl = new FormControl()
  pageSize = 15;
  pageSizeOptions1: number[];
  gg: any;
  itemSelect: any = [];
  company_name: any = '';


  // @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('paginator', {static: true}) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('myDiv') myDiv: ElementRef<HTMLElement>;
  @ViewChild('htmlData') htmlData: ElementRef;
  @ViewChild('pdfTable', {static: false}) pdfTable: ElementRef;

  filterValues = {};
  json: any;
  Itemss: any;
  ddd: boolean;
  entry: any;
  lengthSelected: number;
  textSelected: string;
  inputEt: boolean;
  IconOn: boolean;
  IconOnn: boolean;
  IconOnItems: string;
  color: any;

  hiddenItemClick: any = 0;
  name: any;
  driver: any;
  company: any;
  calibration: any;
  calibrationsearch: any = ["Calibrating", "Ready"];
  unit_type: any;
  spinnerActiveVehicule: boolean = false;
  spinnerActiveVehiculeGET: boolean = false;
  showspinner: number;

  roleuser: any = "User";
  userinfo: any = null;
  companies: any[] = [];
  listVehicles: any;
  filtre: any;

  constructor(private _snackBar: MatSnackBar, public dialog: MatDialog,
              public traslateService: TraslateService,
              private activatedRoute: ActivatedRoute, private http: HttpClient,
              private userService: UserService, private spinnerVehicule: NgxSpinnerService, private cdRef: ChangeDetectorRef) {

    this.activatedRoute.data.subscribe(async data => {
      this.roleuser = data.roles[0]


      // User
    })

    if (this.roleuser == "User") {

      this.userService.getById().pipe(first()).subscribe(user => {

        this.userinfo = user[0];
        //   this.loading = false;
        // //  this.userFromApi = user;


        //   if (user.status== "Token is Expired") {
        //    this.logout()
        //   }
        this.getVehiculeUser(15, "");

      });
      this.filterSelectObj = [

        {
          name: 'calibration',
          columnProp: 'calibration',
          options: []
        }
        , {
          name: 'type',
          columnProp: 'unit_type',
          options: []
        }
      ]


    } else {
      this.filterSelectObj = [

        {
          name: 'calibration',
          columnProp: 'calibration',
          options: []
        }
        , {
          name: 'compagnie',
          columnProp: 'company',
          options: []
        }
        , {
          name: 'type',
          columnProp: 'unit_type',
          options: []
        }
      ]
      this.getVehicule(15, "")

    }


    this.traslateService.obs1.subscribe((response: any) => {
      this.traslateService.getTypeVehicule();
      this.typeVehicules = response.vehicle_types;

    });
    this.index2 = 15
    // Object to create Filter for


  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }


  getComapnies() {
    this.traslateService.getCompanies().subscribe((response: any) => {
      this.companies = response.companies;
      this.getRemoteData()
    })
  }


  filteredData;

  applyFilter(evt: string) {

    evt = evt + "";
    if (!evt) this.filteredData = this.companies;
    else {
      /** uses both id and text fields for extensive filtering (case insensitive) . can be tailored for custom needs */
      this.filteredData = this.companies.filter(item => (item.id + "") === evt || item.name.toLocaleLowerCase().indexOf(evt.toLocaleLowerCase()) >= 0);
    }
  }

  valueMapper = (key) => {
    let selection = this.companies.find(e => {
      return e.id == key;
    });
    if (selection) {
      return selection.name;
    }
  };

  getgogo() {

    localStorage.setItem('numberItems', this.selection.selected.length.toString());
    this.hiddenItemClick = localStorage.getItem("numberItems")
  }

  ngAfterViewInit() {


    // this.updateManualPage2(this.index2)

  }

  updateColor(progress) {
    if (progress == "Ready") {
      return '#28a745';

    } else {
      return '#dc3545';
    }
  }

  updateTitle(title) {
    if (title == "Calibrating") {
      return '!';

    } else {
      return 'Ok';
    }
  }


  listUnitTrigger() {
    this.listUnit(1, null)
  }

  listUnit(pageIndex, filtre?) {
    this.spinnerActiveVehiculeGET = false


    this.spinnerActiveVehicule = true

    this.spinnerVehicule.show();
    this.traslateService.getVehicules(pageIndex, filtre).subscribe((response: any) => {

      this.repos = response.vehicles.data
      this.listVehicles = response.vehicles
      this.dataSource = new MatTableDataSource(this.repos);


      this.getRemoteData()

      this.dataSource.filterPredicate = this.createFilter();

      this.spinnerVehicule.hide();
      this.spinnerActiveVehicule = false
      this._snackBar.open('les données des vehicules actualiser ', 'Fermer', {
        duration: 2000,

      });

    })
  }


// pageChanged(event) {
//     let pageIndex = event.pageIndex;


//   let pageSize = event.pageSize;

//   let previousIndex = event.previousPageIndex;

//   let previousSize = pageSize * pageIndex;

//   this.getVehiculeUser(
//     previousSize,
//     pageIndex+1
//   );
// }
  pageChanged(event) {

    let pageIndex = event.pageIndex;


    let pageSize = event.pageSize;

    let previousIndex = event.previousPageIndex;

    let previousSize = pageSize * pageIndex;


    if (this.roleuser == "User") {
      this.getVehiculeUser(
        previousSize,
        (pageIndex + 1).toString()
      );


    } else {
      this.getVehicule(
        previousSize,
        (pageIndex + 1).toString()
      );
    }
  }


  searchbyname: any = "";
  searchbyIDboitr: any = "";


  searchbyunit_type: any = "";
  searchbycalibration: any = "";
  searchbydeviceid: any = "";
  searchbycompnid: any = "";

  async getVehiculeUser(currentSize, offset) {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActiveVehiculeGET = true
    this.spinnerActiveVehicule = true
    this.spinnerVehicule.show();
    https://apid.stg-app.com/stgdrive-dev/index.php/api/companies/209/units?page=1&name=10018 B&unit_type=2
      await this.http.get(environment.apiUrl + '/companies/' + this.userinfo.company_id + '/units' + '?page=' + offset + '&name=' + this.searchbyname + "&unit_type=" + this.searchbyunit_type + "&calibration=" + this.searchbycalibration, requestOptions).subscribe(async (response: any) => {
        this.spinnerActiveVehiculeGET = false
        this.spinnerActiveVehicule = false

        // var listVehicule: any = response

        //   this.lengthTotal = listVehicule.vehicles.total
        //   this.Itemss = listVehicule.vehicles.data
        //   this.Itemss.length = currentSize ;
        //   this.repos = listVehicule.vehicles.data
        //   this.repos.length = currentSize ;
        //   this.repos.length = listVehicule.vehicles.total ;

        //   // this.repos.length = listVehicule.vehicles.total;

        //   this.dataSource = new MatTableDataSource(this.repos);
        //   this.dataSource._updateChangeSubscription();

        //   this.dataSource.paginator = this.paginator;
        //   this.dataSource.sort = this.sort;


        // this.Itemss.length = currentSize ;

        // list.length = response.vehicles.total;
        // this.repos = response.vehicles.data
        // this.repos.length = currentSize ;

        var list: any = response.vehicles.data;
        this.lengthTotal = response.vehicles.total
        // this.Itemss = response.vehicles.data
        // this.Itemss.length = response.vehicles.per_page ;

        // list.length = response.vehicles.total;
        if (currentSize == 0) {
          list.length = 15;
        } else {
          list.length = currentSize;
        }
        // list.length =currentSize ;
        this.repos = response.vehicles.data
        // this.repos.length = response.vehicles.per_page
        this.repos.push(...list);
        // this.devices.length = currentSize ;
        // this.dataSource = new MatTableDataSource([]);
        this.repos.length = response.vehicles.total;
        // this.paginator.pageSize = response.vehicles.per_page

        // this.paginator.length = response.vehicles.per_page
        // this.paginator.pageIndex = response.vehicles.currentSize


        this.dataSource = await new MatTableDataSource<any>(this.repos);
        this.dataSource._updateChangeSubscription();

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.getRemoteData()

        this.spinnerActiveVehiculeGET = false
        this.spinnerActiveVehicule = false
        // Overrride default filter behaviour of Material Datatable
        this.dataSource.filterPredicate = this.createFilter();
        this.spinnerVehicule.hide();
        // this.spinnerActiveVehiculeGET = true

      })
  }

  getVehicule(currentSize, offset) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActiveVehiculeGET = true
    this.spinnerActiveVehicule = true
    this.spinnerVehicule.show();
    this.http.get(environment.apiUrl + '/unit/list' + '?page=' + offset
      + '&company_id=' + this.searchbycompnid
      + "&unit_type=" + this.searchbyunit_type +
      "&calibration=" + this.searchbycalibration +
      "&device_id=" + this.searchbydeviceid,
      requestOptions).subscribe((response: any) => {
      var list: any = response.vehicles.data;
      this.lengthTotal = response.vehicles.total
      if (currentSize == 0) {
        list.length = 15;
      } else {
        list.length = currentSize;
      }
      this.repos = response.vehicles.data
      this.repos.push(...list);
      this.repos.length = response.vehicles.total;
      this.dataSource = new MatTableDataSource<any>(this.repos);
      this.dataSource._updateChangeSubscription();

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.getRemoteData()

      this.spinnerActiveVehiculeGET = false
      this.spinnerActiveVehicule = false
      // Overrride default filter behaviour of Material Datatable
      this.dataSource.filterPredicate = this.createFilter();
      this.spinnerVehicule.hide();
      this.spinnerActiveVehiculeGET = true

    })
  }

  ngOnInit() {
    this.getComapnies()

  }

  deleteOneOrmultiple() {


  }

  collection: any = [];
  pageIndex;

  nextpageevehicle(event: any) {



    this.pageIndex = event.pageIndex;
    let pageSize = event.pageSize;

    let previousIndex = event.previousPageIndex;
    // let previousSize = pageSize * this.pageIndex;
  }

  public updateManualPage2(index2) {

    this.collection = []

    this.paginator.pageSize = index2


    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: index2,
      length: this.paginator.length
    });


    this.lengthpage = parseInt("" + (this.paginator.length + 1) / index2)


    //Create dummy data
    for (var i = 0; i < this.lengthpage; i++) {
      this.collection.push(i + 1);
    }


  }

  public updateManualPage(index): void {
    this.pageNum = index
    this.manualPage = index;
    this.paginator.pageIndex = index;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length
    });


  }


  exportExcel(e, e2) {


    Swal.fire({
      title: 'Souhaitez-vous exporter la table type .' + e2 + ' ?',
      showCancelButton: true,
      confirmButtonText: 'Exporter Fichier !',
      cancelButtonText: 'Annuler',
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Exporté',
          'Le fichier est exporté.'
        )
        e.exportTable(e2, {
          fileName: 'STG_DRIVE_vehicules_date_' + new Date().toLocaleString(),
          sheet: 'STG DRIVE vehicules',
          Props: {'Author': 'STG_DRIVE'}
        })

      } else if (result.dismiss === Swal.DismissReason.cPDFfileancel) {
        Swal.fire(
          'Annulé',
          'Fichier non exporté !!',
        )
      }
    })

  }


  exportTable() {

    Swal.fire({
      title: 'Souhaitez-vous exporter la table ?',
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: 'Exporter Fichier !',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {


        PdfUtil.exportToPdf("ExampleTable", "tbl");

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Annulé',
          'Fichier non exporté !!'
        )
      }
    })

  }

  async getItemsbyClick(operation, row) {
    if (operation == 'oneItem') {
      this.selection.clear()
      this.listItems = []
      this.arr = []
      this.listItems.push(row)
    }
    this.lengthSelected = this.listItems.length
    for (let entry of this.listItems) {
      this.entry = entry.id
      this.name = entry.name
      this.driver = entry.driver
      this.company = entry.company
      this.calibration = entry.calibration
      this.unit_type = entry.unit_type

    }
    this.lengthSelected = this.listItems.length
    this.lengthSelected = this.listItems.length

    for (let entry of this.listItems) {
      this.entry = entry.id
    }


    for (let entry of this.listItems) {
      this.entry = entry.id
    }


    Swal.fire({

      border: ' 1px solid #262853',
      width: 900,
      opacity: 1,
      background: 'rgba(238,238,238,0)',
      showConfirmButton: false,
      html:
        '<div style="background: rgba(255, 255, 255, 0.8);border-radius: 16px;box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);backdrop-filter: blur(13.7px);' +
        '-webkit-backdrop-filter: blur(8px);border: 1px solid rgba(255, 255, 255, 0.22);  border: 1px solid #262853;border-radius: 25px;">' +
        '<div>' +
        // '<div class="close" style="margin-top: -25px; margin-right: 15px" >x</div>'

        '<h1 class="pb-4" style="color :#262756;margin-right: 50%;margin-top: 5%;" > <strong> Détails du véhicule </strong> <h1>' +
        '</div>' +
        '<table class="swal" style="color :#262756;margin-left: 15%; text-align: left; margin-bottom: 10%;">' +
        ' <tr style="height: 24px !important;" ><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Nom : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' + this.name + '</h3></td></tr>' +
        ' <tr style="height: 14px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;">Driver : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' + this.driver + '</h3></td></tr>' +
        ' <tr style="height: 4px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;">Calibration Statut : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' + this.calibration + '</h3></td></tr>' +
        ' <tr style="height: 14px; padding:0px; margin:0px;"><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Compagnie : </h2></td><td><h3 style="font-size: 15px;padding:0px; margin:0px;"> ' + this.company + '</h3></td></tr>' +
        ' <tr style="height: 14px; padding:0px; margin:0px;"><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Type Unité : </h2></td><td><h3 style="font-size: 15px;padding:0px; margin:0px;"> ' + this.unit_type + '</h3></td></tr>' +
        '</table>' +
        '</div>',

    }).then(() => {
      this.listItems = []
      this.arr = []
      this.selection.clear()
    });


  }


  // Get Uniqu values from columns to build filter
  getFilterObject(fullObj, key) {


    let uniqChk = [];

    if (key == 'unit_type') {
      uniqChk = ["Petit camion", "Privé", "Bus", "Camionette", "Grand camion"]
    } else if (key == "calibration") {
      uniqChk = ['Ready', 'Calibrating']
    } else if (key == 'company') {
      uniqChk = this.companies
    }

    return uniqChk;
  }

  getRemoteData() {

    this.filterSelectObj.filter((o) => {
      o.options = this.getFilterObject(this.repos, o.columnProp);
    });
  }


  applyFilterer(test) {
    if (this.roleuser == "User") {
      this.getVehiculeUser(15, 1);
    } else {
      this.getVehicule(15, 1);
    }

  }

  applyFiltererbydevcid(test) {
    if (this.roleuser == "User") {
      this.getVehiculeUser(15, 1);
    } else {
      this.getVehicule(15, 1);
    }

  }

  typeVehicules: TypeVehicule[]

  getItemsType() {
    if (this.roleuser == "User") {
      this.getVehiculeUser(15, 1);
    } else {
      this.getVehicule(15, 1);
    }

  }

  getItemscalibration() {
    if (this.roleuser == "User") {
      this.getVehiculeUser(15, 1);
    } else {
      this.getVehicule(15, 1);
    }

  }


  resetdatavihclclbr() {

    if (this.roleuser == "User") {
      this.searchbycalibration = ""
      this.getVehiculeUser(15, 1);
    } else {
      this.searchbycalibration = ""
      this.getVehicule(15, 1);
    }

  }

  resetdatavihcltype() {

    if (this.roleuser == "User") {
      this.searchbyunit_type = ""
      this.getVehiculeUser(15, 1);
    } else {
      this.searchbyunit_type = ""
      this.getVehicule(15, 1);
    }

  }

  resetdatavihclcompny() {

    if (this.roleuser == "User") {
      this.searchbycompnid = ""
      this.getVehiculeUser(15, 1);
    } else {
      this.searchbycompnid = ""
      this.getVehicule(15, 1);
    }

  }

  getOptions(filter) {
    return filter.options
  }

  onChangeEvent(filter, $event) {

    if ($event.target.value != '') {
      filter.options = this.getFilterObject(this.repos, filter.columnProp).filter(option => filter.columnProp == 'company' ? option.name.toLowerCase().includes($event.target.value)
        : option.toLowerCase().includes($event.target.value));

    } else {
      if (filter.columnProp == 'unit_type') {
        this.filtre.unit_type = ''
      } else if (filter.columnProp == 'company') {
        this.filtre.company_id = ''
      }

      this.filterChange(filter, filter.modelValue, true)
      this.getFilterObject(this.repos, filter.columnProp);
      filter.options = this.getFilterObject(this.repos, filter.columnProp);


    }


  }

  filterChange(filter, item, khwi?) {


    this.filterValues[filter.columnProp] = filter.modelValue
    switch (filter.columnProp) {
      case 'company':
        this.filtre.company_id = khwi ? '' : item.id
        break;
      case 'calibration':
        this.filtre.calibration = item

        break;
      case 'unit_type':
        switch (item) {

          case "Petit camion":
            if (khwi) {
              this.filtre.unit_type = ''
            } else {
              this.filtre.unit_type = 1
            }

            break;
          case "Privé":
            this.filtre.unit_type = khwi ? '' : 5
            break;
          case "Bus":
            this.filtre.unit_type = khwi ? '' : 3
            break;
          case "Camionette":
            this.filtre.unit_type = khwi ? '' : 2
            break;
          case "Grand camion":
            this.filtre.unit_type = khwi ? '' : 4
            break;
          default:
            break;
        }

        break;


      default:
        break;
    }


    this.filterValues[filter.columnProp] = filter.modelValue
    this.getVehicule(1, this.filtre)

  }

  value = '';

  filterChangeList(event) {

    this.filterValues["device_id"] = event.target.value.trim().toLowerCase()
    this.filtre.device_id = this.filterValues["device_id"]
    this.getVehicule(1, this.filtre)
  }


  createFilter() {
    let filterFunction = function (data: any, filter: string): boolean {
      let searchTerms = JSON.parse(filter);
      let isFilterSet = false;
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '') {
          isFilterSet = true;
        } else {
          delete searchTerms[col];
        }
      }


      let nameSearch = () => {
        let found = false;
        if (isFilterSet) {
          for (const col in searchTerms) {

            searchTerms[col].trim().toLowerCase().split(' ').forEach(word => {
              if (data[col].toString().toLowerCase() === searchTerms[col].trim().toLowerCase() && isFilterSet) {
                found = true
              }
            });
          }
          return found
        } else {
          return true;
        }
      }
      return nameSearch()
    }
    return filterFunction
  }


  resetFilters() {
    this.value = '';
    this.filterValues["device_id"] = this.value

    this.dataSource.filter = JSON.stringify(this.filterValues)

    this.filterValues = {}
    this.filterSelectObj.forEach((value, key) => {
      value.modelValue = undefined;
    })
    this.dataSource.filter = "";
    this._snackBar.open('les données de filtrage réinitialiser ', 'Fermer', {
      duration: 2500,

    });
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;

    const numRows = this.dataSource?.data.length;


    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :

      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?: any): string {

    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    this.listItems = this.selection.selected
    this.lengthSelected = this.listItems.length
    if (this.lengthSelected == 1) {

      this.IconOnItems = 'ctive'

      this.inputEt = false
    }

    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  arr: any = []

  supprimerItems(operation, id) {
    if (operation == 'oneItem') {
      this.selection.clear()
      this.listItems = []
      this.arr = []
      this.listItems.push({
        id: id,
      })
    }
    for (var i = 0; i < this.listItems.length; i++) {
      var obj = {}; // <---- Move declaration inside loop

      obj['id'] = this.listItems[i].id;

      this.arr.push(this.listItems[i].id);
    }

    Swal.fire({
      title: "Voulez-vous supprimer ce véhicule?",
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: 'Oui',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinnerActiveVehiculeGET = false

        this.spinnerActiveVehicule = true
        this.spinnerVehicule.show();
        this.http.delete(environment.apiUrl + '/units/' + JSON.stringify(this.arr)).subscribe((response) => {
          // this.listUnit()
          // this.getVehiculeUser(  15 , "");
          this.getVehicule(15, "")
          this.spinnerActiveVehicule = false
          this.selection.clear();
          this.hiddenItemClick = 0
          this.arr = []
          this.listItems = []
        })

      } else {
        this.arr = []
        this.listItems = []
        this.selection.clear()
      }
    })


  }


  triggerFalseClick() {


    Swal.fire({
      title: "Êtes-vous sûr?",
      showCancelButton: true,
      confirmButtonText: 'Oui!',
      cancelButtonText: 'Annuler',
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Supprimé!',
        )
        let el: HTMLElement = this.myDiv.nativeElement;
        el.click();


        // For more information about handling dismissals please visit
        // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Annulé'
        )
      }
    })
    location.reload()

  }

  openDialogFileUpload(operation, row: any) {


    if (this.roleuser == "User") {

      let dialogRef = this.dialog.open(EditVehiculeuser, {

        data: {
          animal: 'panda'
        },
        disableClose: true,
        autoFocus: false,

        panelClass: 'my-custom-dialog-class'
      });

      if (operation == 'oneItem') {
        this.selection.clear()
        this.listItems = []
        this.arr = []
        this.listItems.push(row)
      }
      this.traslateService.urlPathQuote.next(this.listItems);
      //  after closed
      dialogRef.afterClosed().subscribe(result => {
        this.selection.clear()
        this.listItems =[]
        this.arr =[]
        let index = this.repos.findIndex(driver => driver?.id === result?.id)
        if (this.repos[index] != undefined) {
          Object.assign(this.repos[index], result?.form);
        }
      });
    } else {

      let dialogRef = this.dialog.open(EditVehicule, {

        data: {
          animal: 'panda'
        },
        disableClose: true,
        autoFocus: false,
        panelClass: 'my-custom-dialog-class'
      });
      if (operation == 'oneItem') {
        this.selection.clear()
        this.listItems = []
        this.arr = []
        this.listItems.push(row)
      }
      this.traslateService.urlPathQuote.next(this.listItems);
      //  after closed
      dialogRef.afterClosed().subscribe(result => {
        this.selection.clear()
        this.listItems =[]
        this.arr =[]
        let index = this.repos.findIndex(driver => driver?.id === result?.id)
        if (this.repos[index] != undefined) {
          Object.assign(this.repos[index], result?.form);
        }

      });
    }

  }

  openDialogFileUpload2() {


    this.dialog.open(AddVehicule, {

      data: {
        animal: 'panda'
      },
      autoFocus: false,

      panelClass: 'my-custom-dialog-class'
    });
    this.traslateService.urlPathQuote.next(this.listItems)
  }


}

interface Food {
  value: string;
  viewValue: string;
}

interface Car {
  value: string;
  viewValue: string;
}


interface TypeVehicule {
  icon: string;
  name: string;
}

interface TypeBoitier {
  name: string;
  type: any;
}


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'EditVehicule',
  templateUrl: 'EditVehicule.html',
  styleUrls: ['./vehicle.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
// tslint:disable-next-line:component-class-suffix
export class EditVehicule {
  selectedValue: string;
  selectedCar: string;
  selectedGroupe: string;
  selectedVehicule: string;
  selectedValue3: string;
  selectedValue4: string;
  value = 'Clear me';

  selected = "Achraf Zghoud";
  panelColor = new FormControl(4);

  groupe: any[] = []
  name: string;
  nameTitle: string
  ff: string;

  checked = false;
  icon2: any;
  name2: any;
  typeBoitierItems: any;
  typeVehicule: any;

  submitStatus: boolean;

  typeVehicules: TypeVehicule[]
  revendeurs: any;
  revendeur: any;
  revendeurCompany: any;
  revendeurCompanyId: any = null;
  conducteurCompany: any;
  url: any;
  entry: any;
  archived: any;
  default_branch: any;
  description: any;
  plate: any;
  brand: any;
  boitier_sim: any;
  device_id: any;
  company: any;


  selectedRevendeur: any;
  idCompany: any;
  revendeurCompanySelect: any;
  reseller_id: any;
  unit_type: any;
  driver: any;
  unit_type_id: any;
  icon: any;
  spinnerActiveEdit: boolean = false;


  constructor(public dialogRef: MatDialogRef<AddVehicule>, public traslateService: TraslateService, private http: HttpClient, private formBuilder: FormBuilder, private spinnerVehicule: NgxSpinnerService) {
    this.traslateService.obs1.subscribe((response) => {
      this.traslateService.getTypeVehicule();
      this.typeVehicule = response;
      this.click()

    });


  }

  myControl = new FormControl();
  options: any[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<any[]>;


  companyname: any = "";

  ngOnInit(): void {
    this.traslateService.currentdataQuote.subscribe(data => {
      this.url = data
    })


    for (let entry of this.url) {
      this.entry = entry.id
      this.name = entry.name
      this.nameTitle = entry.name
      this.plate = entry.plate
      this.brand = entry.brand
      this.boitier_sim = entry.boitier_sim
      this.device_id = entry.device_id
      this.driver = entry.driver
      this.company = entry.company
      this.idCompany = entry.company_id
      this.reseller_id = entry.reseller_id
      if (isNaN(Number(entry.unit_type))) {
        switch (entry.unit_type) {
          case  "Petit camion" : {
            this.unit_type = "Petit camion"
            this.unit_type_id = 1
            break;
          }
          case "Camionette" : {
            this.unit_type = "Camionette"
            this.unit_type_id = 2
            break;
          }
          case "Bus" : {
            this.unit_type = "Bus"
            this.unit_type_id = 3
            break;
          }
          case "Grand camion": {
            this.unit_type = "Grand camion"
            this.unit_type_id = 4
            break;
          }
          case "Privé": {
            this.unit_type = "Privé"
            this.unit_type_id = 5
            break;
          }

        }

      } else {
        switch (entry.unit_type) {
          case 1  : {
            this.unit_type = "Petit camion"
            this.unit_type_id = 1
            break;
          }
          case 2 : {
            this.unit_type = "Camionette"
            this.unit_type_id = 2
            break;
          }
          case 3 : {
            this.unit_type = "Bus"
            this.unit_type_id = 3
            break;
          }
          case 4 : {
            this.unit_type = "Grand camion"
            this.unit_type_id = 4
            break;
          }
          case 5 : {
            this.unit_type = "Privé"
            this.unit_type_id = 5
            break;
          }

        }

      }
      this.companyname = entry.company
      this.icon = entry.icon
    }

    this.getIdrevendeur(this.reseller_id)
    this.getIdConducteur(this.idCompany)
    this.traslateService.obs2.subscribe((response) => {
      this.traslateService.getRevendeur();
      this.revendeur = response;
      this.click2()
    });


  }


  // tslint:disable-next-line:member-ordering
  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    reseller_id: [, {validators: [Validators.required], updateOn: "change"}],
    company_id: [, {validators: [Validators.required], updateOn: "change"}],
    driver: [],
    unit_type: [, {validators: [Validators.required], updateOn: "change"}],
    unit_type_id: [, {validators: [Validators.required], updateOn: "change"}],
    name: [, {validators: [Validators.required], updateOn: "change"}],
    plate: [],
    brand: [],
    device_id: [, {validators: [Validators.required], updateOn: "change"}],
    boitier_sim: [],
    icon: []
  });

  saveUser(data) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.post(environment.apiUrl + '/units', data, requestOptions);
  }


  submitForm() {

    this.spinnerActiveEdit = true
    this.spinnerVehicule.show();

    Object.values(this.registerForm).forEach(val => {
    });
    this.submitStatus = true;

    this.registerForm.get('company_id').setValue(this.idCompany)
    this.registerForm.get('unit_type').setValue(this.unit_type_id)
    this.registerForm.get('unit_type_id').setValue(this.unit_type_id)
    this.http.put(environment.apiUrl + '/units/' + this.entry, this.registerForm.value).subscribe(data => {

      var statusNumber: any = data

      this.spinnerVehicule.hide();
      this.spinnerActiveEdit = false
      //location.reload()


      if (statusNumber.status == 200) {
        Swal.fire({
          position: 'center',
          title: data["message"],
          showConfirmButton: false,
          timer: 1000
        })
        this.spinnerVehicule.hide();
        this.spinnerActiveEdit = false
        this.dialogRef.close({id: this.entry, form: this.registerForm.value});

        // window.location.reload();
      } else {
        this.spinnerVehicule.hide();
        this.spinnerActiveEdit = false
        Swal.fire({
          text: statusNumber.message.join('<br>'),
        })
      }
    })
    //location.reload()
  }

  matcher = new MyErrorStateMatcher();
  date = new FormControl(moment());

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
  }

  click() {


    this.typeVehicules = this.typeVehicule.vehicle_types

  }

  click2() {

    this.revendeurs = this.revendeur?.resellers
    this.selectedRevendeur = this.revendeur?.resellers[this.reseller_id]?.id
  }


  getIdrevendeur(e) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.spinnerActiveEdit = true
    this.spinnerVehicule.show();
    this.http.get(environment.apiUrl + '/resellers/' + e + '/companies/all', requestOptions)
      .subscribe(response => {
        // work with posts
        this.revendeurCompany = response;
        this.revendeurCompanyId = this.revendeurCompany?.companies
        this.spinnerVehicule.hide();
        this.spinnerActiveEdit = false
      })



  }

  getIdConducteur(e) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActiveEdit = true
    this.spinnerVehicule.show();
    this.http.get(environment.apiUrl + '/companies/' + e + '/drivers/all', requestOptions)
      .subscribe(response => {
        // work with posts
        var list: any = response;
        this.conducteurCompany = list.drivers
        this.spinnerVehicule.hide();
        this.spinnerActiveEdit = false
      })



  }

  getItemsType(typeVehicules) {

    this.icon2 = typeVehicules.icon
    this.name2 = typeVehicules.name
    this.registerForm.get('unit_type').setValue(typeVehicules.id)
    this.registerForm.get('icon').setValue(typeVehicules.icon)
    this.unit_type_id = typeVehicules.id
    this.icon = typeVehicules.icon
    this.unit_type = typeVehicules.name
  }

  getItemsBoitierTble(e) {
    this.typeBoitierItems = e.type
  }

  filteredData;

  applyFilter(evt: string) {

    evt = evt + "";
    if (!evt) this.filteredData = this.revendeurCompanyId;
    else {
      /** uses both id and text fields for extensive filtering (case insensitive) . can be tailored for custom needs */
      this.filteredData = this.revendeurCompanyId?.filter(item => (item.id + "") === evt || item.name.toLocaleLowerCase().indexOf(evt.toLocaleLowerCase()) >= 0);
    }
  }

  valueMapper = (key) => {
    let selection = this.revendeurCompanyId?.find(e => {
      return e.id == key;
    });
    if (selection) {
      return selection.name;
    }
  };


  users: any[] = [];

  addUser() {
    this.name = (<HTMLInputElement>document.getElementById('name')).value

    this.users.push(this.name);//push empty object of type user
    this.groupe = this.users
  }

  listUser() {
    this.groupe = this.users
  }


  onNoClickc(): void {

    let timerInterval
    Swal.fire({
      title: 'Auto close alert!',
      html: 'I will close in <b></b> milliseconds.',
      timer: 2000,
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading()
        timerInterval = setInterval(() => {
          const content = Swal.getContent()
          if (content) {
            const b = content.querySelector('b')
            if (b) {
              b.textContent = Swal.getTimerLeft()
            }
          }
        }, 100)
      },
      onClose: () => {
        clearInterval(timerInterval)
      }
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        location.reload()
      }
    })


  }

  onNoClick(): void {
    this.dialogRef.close();


  }

}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'EditVehiculeuser',
  templateUrl: 'EditVehiculeuser.html',
  styleUrls: ['./vehicle.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
// tslint:disable-next-line:component-class-suffix
export class EditVehiculeuser {
  selectedValue: string;
  selectedCar: string;
  selectedGroupe: string;
  selectedVehicule: string;
  selectedValue3: string;
  selectedValue4: string;
  value = 'Clear me';

  selected = "Achraf Zghoud";
  panelColor = new FormControl(4);

  groupe: any[] = []
  name: string;
  nameTitle : string;
  ff: string;

  checked = false;
  icon2: any;
  name2: any;
  typeBoitierItems: any;
  typeVehicule: any;

  submitStatus: boolean;

  typeVehicules: TypeVehicule[]
  revendeurs: any;
  revendeur: any;
  revendeurCompany: any;
  revendeurCompanyId: any = null;
  conducteurCompany: any;
  url: any;
  entry: any;
  archived: any;
  default_branch: any;
  description: any;
  plate: any;
  brand: any;
  boitier_sim: any;
  device_id: any;
  company: any;


  selectedRevendeur: any;
  idCompany: any;
  revendeurCompanySelect: any;
  reseller_id: any;
  unit_type: any;
  driver: any;
  unit_type_id: any;
  icon: any;
  spinnerActiveEdit: boolean = false;


  constructor(public dialogRef: MatDialogRef<AddVehicule>, public traslateService: TraslateService, private http: HttpClient, private formBuilder: FormBuilder, private spinnerVehicule: NgxSpinnerService) {
    this.traslateService.obs1.subscribe((response) => {
      this.traslateService.getTypeVehicule();
      this.typeVehicule = response;
      this.click()

    });


  }

  myControl = new FormControl();
  options: any[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<any[]>;


  ngOnInit(): void {
    this.traslateService.currentdataQuote.subscribe(data => {
      this.url = data
    })


    for (let entry of this.url) {
      this.entry = entry.id
      this.name = entry.name
      this.nameTitle = entry.name
      this.plate = entry.plate
      this.brand = entry.brand
      this.boitier_sim = entry.boitier_sim
      this.device_id = entry.device_id
      this.driver = entry.driver
      this.company = entry.company
      this.idCompany = entry.company_id
      this.reseller_id = entry.reseller_id
      if (isNaN(Number(entry.unit_type))) {
        switch (entry.unit_type) {
          case  "Petit camion" : {
            this.unit_type = "Petit camion"
            this.unit_type_id = 1
            break;
          }
          case "Camionette" : {
            this.unit_type = "Camionette"
            this.unit_type_id = 2
            break;
          }
          case "Bus" : {
            this.unit_type = "Bus"
            this.unit_type_id = 3
            break;
          }
          case "Grand camion": {
            this.unit_type = "Grand camion"
            this.unit_type_id = 4
            break;
          }
          case "Privé": {
            this.unit_type = "Privé"
            this.unit_type_id = 5
            break;
          }

        }

      } else {
        switch (entry.unit_type) {
          case 1  : {
            this.unit_type = "Petit camion"
            this.unit_type_id = 1
            break;
          }
          case 2 : {
            this.unit_type = "Camionette"
            this.unit_type_id = 2
            break;
          }
          case 3 : {
            this.unit_type = "Bus"
            this.unit_type_id = 3
            break;
          }
          case 4 : {
            this.unit_type = "Grand camion"
            this.unit_type_id = 4
            break;
          }
          case 5 : {
            this.unit_type = "Privé"
            this.unit_type_id = 5
            break;
          }

        }

      }
      this.icon = entry.icon
    }
    this.getIdrevendeur(this.reseller_id)
    this.getIdConducteur(this.idCompany)
    this.traslateService.obs2.subscribe((response) => {
      this.traslateService.getRevendeur();
      this.revendeur = response;
      this.click2()
    });


  }


  // tslint:disable-next-line:member-ordering
  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    reseller_id: [, {validators: [Validators.required], updateOn: "change"}],
    company_id: [, {validators: [Validators.required], updateOn: "change"}],
    driver: [],
    unit_type: [, {validators: [Validators.required], updateOn: "change"}],
    name: [, {validators: [Validators.required], updateOn: "change"}],
    unit_type_id: [, {validators: [Validators.required], updateOn: "change"}],
    plate: [],
    icon: [],
    brand: [],
    device_id: [, {validators: [Validators.required], updateOn: "change"}],
    boitier_sim: [],
  });

  saveUser(data) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.post(environment.apiUrl + '/units', data, requestOptions);
  }


  submitForm() {


    this.spinnerActiveEdit = true
    this.spinnerVehicule.show();

    Object.values(this.registerForm).forEach(val => {
    });
    this.submitStatus = true;
    this.registerForm.get('company_id').setValue(this.idCompany)
    this.registerForm.get('unit_type').setValue(this.unit_type_id)
    this.registerForm.get('unit_type_id').setValue(this.unit_type_id)
    this.http.put(environment.apiUrl + '/units/' + this.entry, this.registerForm.value).subscribe(data => {

      var statusNumber: any = data

      this.spinnerVehicule.hide();
      this.spinnerActiveEdit = false
      //location.reload()


      if (statusNumber.status == 200) {
        Swal.fire({
          position: 'center',
          title: data["message"],
          showConfirmButton: false,
          timer: 1000
        })
        this.spinnerVehicule.hide();
        this.spinnerActiveEdit = false
        this.dialogRef.close({id: this.entry, form: this.registerForm.value});

        // window.location.reload();
      } else {
        this.spinnerVehicule.hide();
        this.spinnerActiveEdit = false
        Swal.fire({
          text: statusNumber.message.join('<br>'),

        })
      }
    })
    //location.reload()


  }

  matcher = new MyErrorStateMatcher();


  date = new FormControl(moment());

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
  }

  click() {


    this.typeVehicules = this.typeVehicule.vehicle_types

  }

  click2() {

    this.revendeurs = this.revendeur?.resellers
    this.selectedRevendeur = this.revendeur?.resellers[this.reseller_id]?.id
  }


  getIdrevendeur(e) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.spinnerActiveEdit = true
    this.spinnerVehicule.show();
    this.http.get(environment.apiUrl + '/resellers/' + e + '/companies/all', requestOptions)
      .subscribe(response => {
        // work with posts
        this.revendeurCompany = response;
        this.revendeurCompanyId = this.revendeurCompany?.companies
        this.spinnerVehicule.hide();
        this.spinnerActiveEdit = false
      })



  }

  getIdConducteur(e) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActiveEdit = true
    this.spinnerVehicule.show();
    this.http.get(environment.apiUrl + '/companies/' + e + '/drivers/all', requestOptions)
      .subscribe(response => {
        // work with posts
        var list: any = response;
        this.conducteurCompany = list.drivers
        this.spinnerVehicule.hide();
        this.spinnerActiveEdit = false
      })



  }

  getItemsType(typeVehicules) {

    this.icon2 = typeVehicules.icon
    this.name2 = typeVehicules.name
    this.icon2 = typeVehicules.icon
    this.name2 = typeVehicules.name
    this.registerForm.get('unit_type').setValue(typeVehicules.id)
    this.registerForm.get('icon').setValue(typeVehicules.icon)
    this.unit_type_id = typeVehicules.id
    this.icon = typeVehicules.icon
    this.unit_type = typeVehicules.name
  }

  getItemsBoitierTble(e) {
    this.typeBoitierItems = e.type
  }

  users: any[] = [];

  addUser() {
    this.name = (<HTMLInputElement>document.getElementById('name')).value

    this.users.push(this.name);//push empty object of type user
    this.groupe = this.users
  }

  listUser() {
    this.groupe = this.users
  }


  onNoClickc(): void {

    let timerInterval
    Swal.fire({
      title: 'Auto close alert!',
      html: 'I will close in <b></b> milliseconds.',
      timer: 2000,
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading()
        timerInterval = setInterval(() => {
          const content = Swal.getContent()
          if (content) {
            const b = content.querySelector('b')
            if (b) {
              b.textContent = Swal.getTimerLeft()
            }
          }
        }, 100)
      },
      onClose: () => {
        clearInterval(timerInterval)
      }
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        location.reload()
      }
    })


  }

  onNoClick(): void {
    this.dialogRef.close();


  }

}


export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'AddVehicule',
  templateUrl: 'AddVehicule.html',
  styleUrls: ['./vehicle.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})


// tslint:disable-next-line:component-class-suffix
export class AddVehicule {
  selectedValue: string;
  selectedCar: string;
  selectedGroupe: string;
  selectedVehicule: string;
  selectedValue3: string;
  selectedValue4: string;


  typeBoitier: TypeBoitier[] = [
    {name: 'build', type: ['fgdkl', 'oihjil', 'jkhjk']},
    {name: 'done_all', type: ['fgdkl', 'oihjil', 'jkhjk']},
    {name: 'build', type: ['fgdkl', 'oihjil', 'jkhjk']}
  ];


  cars: Car[] = [
    {value: 'volvo', viewValue: 'options'},
    {value: 'saab', viewValue: 'options'},
    {value: 'mercedes', viewValue: 'options'}
  ];
  groupe: any[] = []
  name: string;
  ff: string;

  checked = false;
  icon2: any;
  name2: any;
  typeBoitierItems: any;
  typeVehicule: any;

  submitStatus: boolean;

  typeVehicules: TypeVehicule[]
  revendeurs: any;
  revendeur: any;
  revendeurCompany: any;
  revendeurCompanyId: any = null;
  conducteurCompany: any;
  spinnerActiveVehiculePost: boolean;
  myControl = new FormControl();

  series3: string[] = []
  filteredOptions: Observable<string[]>;

  constructor(public dialogRef: MatDialogRef<AddVehicule>, public traslateService: TraslateService, private http: HttpClient, private formBuilder: FormBuilder, private spinnerVehicule: NgxSpinnerService) {
    this.traslateService.obs1.subscribe((response) => {
      this.traslateService.getTypeVehicule();
      this.typeVehicule = response;
      this.click()

    });


    this.traslateService.obs2.subscribe((response) => {
      this.traslateService.getRevendeur();
      this.revendeur = response;
      this.click2()
    });
  }


  getvalue() {

  }

  filteredData;

  applyFilter(evt: string) {

    evt = evt + "";
    if (!evt) this.filteredData = this.revendeurCompanyId;
    else {
      /** uses both id and text fields for extensive filtering (case insensitive) . can be tailored for custom needs */
      this.filteredData = this.revendeurCompanyId?.filter(item => (item.id + "") === evt || item.name.toLocaleLowerCase().indexOf(evt.toLocaleLowerCase()) >= 0);
    }
  }

  valueMapper = (key) => {
    let selection = this.revendeurCompanyId?.find(e => {
      return e.id == key;
    });
    if (selection) {
      return selection.name;
    }
  };


  ngOnInit(): void {
    this.filteredOptions = this.registerForm.get('driver').valueChanges.pipe(
      map(value => this._filter(value))
    );


  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.series3.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  //reseller_id ,name, plate, brand, unit_type, driver, company_id, device_id, boitier_sim


  // tslint:disable-next-line:member-ordering
  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    reseller_id: [, {validators: [Validators.required], updateOn: "change"}],
    company_id: [, {validators: [Validators.required], updateOn: "change"}],
    driver: [],
    unit_type: [, {validators: [Validators.required], updateOn: "change"}],
    name: [, {validators: [Validators.required], updateOn: "change"}],
    plate: [],
    brand: [],
    device_id: [, {validators: [Validators.required], updateOn: "change"}],
    boitier_sim: [],
  });

  saveUser(data) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.post(environment.apiUrl + '/units', data, requestOptions);
  }


  submitForm() {


    Object.values(this.registerForm).forEach(val => {
    });
    this.submitStatus = true;


    this.spinnerActiveVehiculePost = true
    this.spinnerVehicule.show();
    this.http.post(environment.apiUrl + '/units', this.registerForm.value).subscribe(data => {
      var statusNumber: any = data

      this.spinnerVehicule.hide();
      this.spinnerActiveVehiculePost = false

      if (statusNumber.status == 200) {
        Swal.fire({
          position: 'center',
          title: data["message"],
          showConfirmButton: false,
          timer: 1000
        })

        this.spinnerVehicule.hide();
        this.spinnerActiveVehiculePost = false


        window.location.reload();
      } else {

        this.spinnerVehicule.hide();
        this.spinnerActiveVehiculePost = false

        Swal.fire({
          text: statusNumber.message.join('<br>'),

        })
      }

    })

    //location.reload()

  }

  matcher = new MyErrorStateMatcher();


  date = new FormControl(moment());

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
  }

  click() {


    this.typeVehicules = this.typeVehicule.vehicle_types

  }

  click2() {
    this.revendeurs = this.revendeur.resellers

  }

  getIdrevendeur(e) {


    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.spinnerActiveVehiculePost = true
    this.spinnerVehicule.show();
    this.http.get(environment.apiUrl + '/resellers/' + e + '/companies/all', requestOptions)
      .subscribe(response => {

        // work with posts
        this.revendeurCompany = response;
        this.revendeurCompanyId = this.revendeurCompany?.companies
        this.filteredData = this.revendeurCompanyId
        this.spinnerVehicule.hide();
        this.spinnerActiveVehiculePost = false

      })



  }


  getIdConducteur(e) {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.spinnerActiveVehiculePost = true
    this.spinnerVehicule.show();
    this.http.get(environment.apiUrl + '/companies/' + e + '/drivers/all', requestOptions)
      .subscribe(response => {
        // work with posts


        var list: any = response;
        this.conducteurCompany = list.drivers

        this.conducteurCompany?.forEach(element => {
          this.series3 = []
          this.series3.push(
            element.name
          );
        })
        this.spinnerVehicule.hide();
        this.spinnerActiveVehiculePost = false
      })



  }

  getItemsType(typeVehicules) {

    this.icon2 = typeVehicules.icon
    this.name2 = typeVehicules.name
  }

  getItemsBoitierTble(e) {
    this.typeBoitierItems = e.type
  }

  users: any[] = [];

  addUser() {
    this.name = (<HTMLInputElement>document.getElementById('name')).value

    this.users.push(this.name);//push empty object of type user
    this.groupe = this.users
  }

  listUser() {
    this.groupe = this.users
  }


  onNoClickc(): void {

    let timerInterval
    Swal.fire({
      title: 'Auto close alert!',
      html: 'I will close in <b></b> milliseconds.',
      timer: 2000,
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading()
        timerInterval = setInterval(() => {
          const content = Swal.getContent()
          if (content) {
            const b = content.querySelector('b')
            if (b) {
              b.textContent = Swal.getTimerLeft()
            }
          }
        }, 100)
      },
      onClose: () => {
        clearInterval(timerInterval)
      }
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        location.reload()
      }
    })


  }

  onNoClick(): void {
    this.dialogRef.close();


  }

}
